
import {throwError as observableThrowError,  Observable, BehaviorSubject } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {

    private _config: Object;
    public error$: BehaviorSubject<any> = new BehaviorSubject(null);
    constructor(private http: HttpClient) { }

    load() {
        // json files will be loaded here
        return new Promise((resolve, reject) => {
            this.http.get('assets/config/app.config.json').pipe(
                map((res: any) => res),
                catchError((error: any) => {
                   // console.error(error);
                    return observableThrowError(error.error || 'Server error');
                }),)
                .subscribe((data: any) => {
                    this._config = data;
                    resolve(true);
                });
        });
    }

    get(key: any) {
       sessionStorage.setItem(key, this._config[key]);
        return this._config[key];
    }
    logOut() {
        sessionStorage.removeItem('auth');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('tokenExpiration');
        sessionStorage.removeItem('refreshAt');
        sessionStorage.removeItem('lockScreen');
        // this.removealliteminlocalStore();
    }
    bounceUserOut() {
        this.logOut();
        this.error$.next('error');
    }
// tslint:disable-next-line:eofline
};
